import * as R from 'ramda'
import { Products } from '../actions'

const DEFAULT_STATE = {
  all: [],
  featured: [],
}

const reducer = (state = DEFAULT_STATE, action) =>
  R.cond([
    [
      R.equals(Products.TYPE.receive_all),
      () => R.merge(state, { all: action.payload }),
    ],
    [
      R.equals(Products.TYPE.receive_featured),
      () => R.merge(state, { featured: action.payload }),
    ],
    [R.T, R.always(state)],
  ])(action.type)

export default reducer
